import React from 'react';
import cn from 'classnames';
import { object } from 'prop-types';
import DateTime from '../DateTime/DateTime';
import TicketsStatus from './TicketsStatus';

const propTypes = {
  ticket: object.isRequired,
};
const defaultProps = {
  ticket: {},
};
const TicketsListItem = ({ ticket, toggleTicketModal }) => (
  <tr onClick={toggleTicketModal} className="tickets-list-item">
    <td>{ticket.id}</td>
    <td>
      <DateTime timestamp={ticket.created} />
    </td>
    <td>
      <span className={cn('tickets-list-item-title', { 'font-weight-bold': !ticket.isRead })}>
        {ticket.title ? ticket.title : `Ticket #${ticket.id}`}
      </span>
    </td>
    <td>
      <TicketsStatus status={ticket.status} isRead={ticket.isRead} />
    </td>
    <td>{ticket.answers}</td>
  </tr>
);

TicketsListItem.propTypes = propTypes;
TicketsListItem.defaultProps = defaultProps;

export default TicketsListItem;
